import { useState, useEffect } from 'react'

import { mySalesService } from '../Services/mySalesService'

export const useMonthlySummary = (monthsCount = null) => {
  const [monthlySummary, setMonthlySummary] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false
    setIsLoading(true)

    const fetchSummary = async () => {
      try {
        const data = await mySalesService.getMonthlySummary({ monthsCount })
        if (cancelled) return
        const dataWithFinalEarnings = (data || []).map((row) => ({
          ...row,
          revenue: (Number(row.revenue) || 0) + (Number(row.donations) || 0),
          finalEarnings: (Number(row.revenue) || 0),
        }))
        setMonthlySummary(dataWithFinalEarnings)
      } catch (err) {
        if (!cancelled) setError(err)
      } finally {
        if (!cancelled) setIsLoading(false)
      }
    }

    fetchSummary()

    return () => {
      cancelled = true
    }
  }, [monthsCount])

  return {
    monthlySummary,
    isLoading,
    error,
  }
}
